import React from "react";
import DashboardPresenter from "./DashboardPresenter";
import BaseListPage from "../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import { getCurrentUserUseCase } from "../../usecases/user";
import withRouter from "../../withRouter.js";
import { InfiniteScroll } from "../../nq-component";
import DatesFilter from "../../components/DatesFilter";
import AnalyticsContainer from "./components/AnalyticsContainer/index.js";
import PageHeader from "../../components/PageHeader/index.js";
import BankCards from "../../components/BankCards/index.js";

class DashboardPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      category: "Monthly",
      year: new Date().getFullYear(),
      month: new Date().toLocaleString("default", { month: "long" }) || "",
      biYear: "",
      yearly: "",
      objects: [],
      allObjects: [],
      query: {},
      half: "1st Half",
      quarter: "1st Quarter",
      receipts: [],
      sales: [],
      banks: [],
      banksLoading: false,
    };
    this.presenter = new DashboardPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      getCurrentUserUseCase(),
      getObjectUseCase(),
    );
  }

  getCollectionName() {
    return "purchases";
  }

  getMonths() {
    const { year } = this.state;

    const months = Array.from({ length: 12 }, (_, i) => {
      return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
        new Date(year, i, 1),
      );
    });

    return months;
  }

  getClientId() {
    return this.props.params.id;
  }

  getObjects() {
    this.presenter.getObjects();
  }

  onFilter() {
    this.presenter.init();
    this.presenter.getObjects();
  }

  onChange(value, field) {
    this.setState(value);
  }

  showBanksLoading() {
    this.setState({ banksLoading: true });
  }

  hideBanksLoading() {
    this.setState({ banksLoading: false });
  }

  render() {
    const {
      progress,
      category,
      year,
      month,
      years,
      quarter,
      half,
      allObjects,
      receipts,
      sales,
      banks,
      banksLoading,
    } = this.state;
    const user = this.getCurrentUser();
    const months = this.getMonths();
    const yearToNumber = Number(year);

    const isAdmin = this.isAdmin();

    return (
      <>
        <InfiniteScroll className="p-3 p-xl-4 overflow-auto">
          <div className="d-flex flex-column gap-4">
            {/* Header Section */}

            <PageHeader
              breadcrumb={[
                { label: "Home", path: "/" },
                { label: "Dashboard" },
              ]}
              title={"Dashboard"}
              backButton={isAdmin}
              loading={banksLoading}
              description={
                "Overview of your business performance and analytics"
              }
            />

            {/* Filters Card */}

            <DatesFilter
              category={category}
              year={yearToNumber}
              month={month}
              months={months}
              onChange={this.onChange.bind(this)}
              onFilter={this.onFilter.bind(this)}
              quarter={quarter}
              half={half}
            />

            <BankCards title objects={banks} isLoading={banksLoading} />

            <hr className="m-0"></hr>
            {/* Analytics Section */}

            <AnalyticsContainer
              isLoading={progress}
              months={months}
              receipts={receipts}
              sales={sales}
              allObjects={allObjects}
              category={category}
              month={month}
              year={yearToNumber}
              years={years}
              quarter={quarter}
              half={half}
            />
          </div>
        </InfiniteScroll>
      </>
    );
  }
}

export default withRouter(DashboardPage);
